import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import Slide from "@mui/material/Slide";

import { Typography, Button, Icon, IconButton } from "@mui/material";
import { Box } from "@mui/system";

import CircleProgressBar from "../../../Components/ProgressBar/CircleProgressBar";
import StudentCardProgress from "../../../Components/ProgressBar/StudentCardProgress";
import { joinByKeys, getClassNames, randomNumber } from "../../../Js/Common";
import { uniqWith, isEqual, filter, find } from "lodash";
import { upsertSelfLearnProgress } from "../../Assets/Services.js";
import { getProgressLog } from "../../Assets/Services.js";

import {
  getAssetsData,
  getTasksUuid,
  getUserLogs,
  getAssignmentLearnerSummaryLog,
} from "../Services";
import CardAssetList from "./CardAssetList";
import Crunker from "crunker";
import worker_script from "../../../Js/mp3Worker.js";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import { commonSliceActions } from "../../../Store/Slices/CommonSlice";

import PolarChart from "./PolarChart";
import PolarChartModal from "../../../Components/Modal/PolarChartModal";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import RatingModal from "../../../Components/Modal/RatingModal";
import { userLogs } from "../../../Js/Common";
import { getFormatedTime } from "../../../Js/TimeAndDate.js";

const LearnerAssetList = (props) => {
  const navigation = useNavigate();
  const classes = useStyles();
  const wasCalled = useRef(false);
  const dispatch = useDispatch();
  const listInnerRef = useRef();
  const paginationVal = 10;

  // Redux stateis
  // const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { paramsdata } = useSelector((state) => state.common);
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);

  //Status
  const [assignmentData, setAssignmentData] = useState(null);
  const [learnerData, setLearnerData] = useState(null);
  const [exeToEval, setExeToEval] = useState([]);
  const [exeNotToEval, setExeNotToEval] = useState([]);
  const [correctAsset, setCorrectAsset] = useState(0);

  const [tasks, setTasks] = useState(null);
  const [taskType, setTaskType] = useState(null);
  const [assignContext, setAssignContext] = useState([]);
  const [totalData, setTotalData] = useState(null);

  const [skipData, setSkipData] = useState(0);
  const [limitData, setLimitData] = useState(paginationVal);
  const [isFetching, setIsFetching] = useState(false);
  const [polarChartVisible, setPolarChartVisible] = useState(false);

  const [assessmentLevel, setAssessmentLevel] = useState(null);

  const [evaluateAssetArr, setEvaluateAssetArr] = useState([
    "REC",
    "DIC",
    "NB",
    "CI",
    "BOOK",
  ]);
  const [assetData, setAssetData] = useState([]);
  const [learnerRating, setLearnerRating] = useState(0);

  const [assignmentSummaryLog, setAssignmentSummaryLog] = useState([]);
  const [sessionUid, setSessionUid] = useState(null);
  const [ratingNotAvailable, setRatingNotAvailable] = useState(false);
  const [ratingModl, setRatingModl] = useState(false);

  useEffect(() => {
    console.log("paramsdata====>", paramsdata);
    if (paramsdata !== null) {
      setAssignmentData(paramsdata.reportData);
      setLearnerData(paramsdata.learnerData);
      setCorrectAsset(paramsdata.learnerData.genericscore);
      setTotalData(paramsdata.learnerData.attempted_assets_ids.length);
      setAssignContext(paramsdata.learnerData.attempted_assets_ids);
    }
  }, [paramsdata]);

  useEffect(() => {
    if (assignmentData != null) {
      const getInitialData = async () => {
        await fetchTaskData();
      };
      getInitialData();
    }
  }, [assignmentData]);

  useEffect(() => {
    const innerFun = async () => {
      let response = await getProgressLog(learnerData.uid, userInfo.site_uuid);
      setAssessmentLevel(response.data.data[0]["outcome"]["assessmentLevel"]);
    };
    if (siteConfig.customer?.addOnInfo?.isSelfLearning) {
      innerFun();
    }
  }, [siteConfig, learnerData]);

  //Set Pagination and assignContext
  useEffect(() => {
    if (totalData) {
      getAssignmentRating();
    }
  }, [totalData]);

  useEffect(() => {
    if (wasCalled.current) return;
    if (tasks) {
      wasCalled.current = true;
      const getData = async () => {
        //console.log("first time");
        await fetchData();
        await fetchLearnerSummaryLog();
      };
      getData();
    }
  }, [tasks]);

  useEffect(() => {
    const paginationRender = async () => {
      await fetchData();
    };
    if (isFetching) {
      paginationRender();
    }
  }, [isFetching]);

  //getAssignmentLearnerSummaryLog

  const handleInfinityScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      let totalHeight = Math.ceil(scrollTop + clientHeight);
      if (
        totalHeight >= scrollHeight ||
        totalHeight == scrollHeight - 1 ||
        totalHeight === scrollHeight
      ) {
        return true;
      }
      return false;
    }
  };

  const handleLoadMore = () => {
    setTimeout(() => {
      if (skipData / paginationVal < Math.ceil(totalData / paginationVal) - 1) {
        setSkipData(() => limitData);
        setLimitData(() => limitData + paginationVal);
        setIsFetching(() => true);
      }
    }, 1000);
  };

  const fetchTaskData = async () => {
    let params = {
      query: {
        $select: ["uid", "data1", "title", "tasktype", "tags"],
        uid: assignmentData.tasks.tasks,
        site_uuid: assignmentData.site_uuid,
      },
    };
    let resTaskData = await getTasksUuid(params);
    let taskArr = [];
    let exeToEvalArr = [];

    resTaskData.data.forEach((element) => {
      let ob = {};
      ob.taskId = element.uid;
      ob.taskName = element.title;
      ob.tags = element.tags;
      if (element.data1.evaluationExe != undefined) {
        exeToEvalArr = exeToEvalArr.concat(element.data1.evaluationExe);
      }
      taskArr.push(ob);
      setTaskType(element.tasktype);
    });
    setExeToEval(exeToEvalArr);
    setTasks(taskArr);
  };

  const fetchLearnerSummaryLog = async () => {
    let params = {
      query: {
        $select: ["uid", "outcome", "verb"],
        actor: learnerData.uid,
        target: assignmentData.uid,
        site_uuid: assignmentData.site_uuid,
      },
    };
    let resSummaryLogs = await getAssignmentLearnerSummaryLog(params);
    console.log("resSummaryLogs===>", resSummaryLogs);
    setAssignmentSummaryLog(resSummaryLogs.data);
  };

  const fetchData = async () => {
    dispatch(commonSliceActions.setLoader(true));
    let newArr = assignContext.slice(skipData, limitData);
    await callUserAttemptAssets(newArr);
  };

  const callUserAttemptAssets = async (userAttemptedAssets) => {
    let assetArr = [];
    let exeNotToEvalArr = [];

    let params = {
      query: {
        verb: "attemptAssignment",
        target: assignmentData.uid,
        context: { $in: userAttemptedAssets },
        actor: learnerData.uid,
        site_uuid: assignmentData.site_uuid,
        $sort: {
          createdAt: -1,
        },
        $limit: -1,
      },
    };

    let res = await getUserLogs(params);
    console.log("res===>", res);
    let resArr = res.data;
    setSessionUid(resArr[0]["session_uid"]);
    for (let i = 0; i < userAttemptedAssets.length; i++) {
      if (taskType != "media") {
        let tmpArr = filter(resArr, function (o) {
          return (
            o.context.assetId == userAttemptedAssets[i].assetId &&
            o.context.taskID == userAttemptedAssets[i].taskID
          );
        });
        let resAssetsData = await callAssetsData(
          tmpArr,
          userAttemptedAssets[i]
        );

        if (res.data.length !== 0) {
          assetArr.push(resAssetsData);
        }

        if (
          evaluateAssetArr.indexOf(
            resAssetsData.assetContent.content.info.asset_type_alias
          ) !== -1
        ) {
          if (exeToEval.indexOf(resAssetsData.assetUid) == -1) {
            exeNotToEvalArr.push(resAssetsData.assetUid);
          }
        }
      }
    }

    setExeNotToEval((prevData) => [...prevData, ...exeNotToEvalArr]);
    setAssetData((prevData) => [...prevData, ...assetArr]);
    setIsFetching(false);
    dispatch(commonSliceActions.setLoader(false));
  };

  const callAssetsData = async (usrAsset, con) => {
    let params = {
      query: {
        $select: ["asset_name", "content"],
        asset_uid: con.assetId,
      },
    };
    let resAssetsData = await getAssetsData(params);
    let assetData1 = resAssetsData.data[0];
    let taskObj = tasks.find(function (obj) {
      return obj.taskId === con.taskID;
    });
    let obj = {};

    obj.assetUid = con.assetId;
    obj.assetName = assetData1.asset_name;
    obj.assetType = assetData1.content.content.info.asset_type_alias;
    obj.taskName = taskObj.taskName;
    obj.assetContent = assetData1.content;
    obj.data = usrAsset;
    return obj;
  };

  const getAssignmentRating = async () => {
    let params = {
      query: {
        $select: ["id", "outcome"],
        verb: "ratingAssignment",
        target: assignmentData.uid,
        actor: learnerData.uid,
        $limit: -1,
      },
    };
    let res = await getUserLogs(params);
    // console.log("learnerRatingRes====>",res);
    if (res.data.length > 0) {
      let learnerRatingRes = res.data[0].outcome.learnerRating;
      setLearnerRating(learnerRatingRes);
    }
    if (
      learnerData.attemptedassets == learnerData.totalAssets &&
      res.data.length == 0
    ) {
      setRatingNotAvailable(true);
    }
  };

  const downloadBook = async () => {
    let params = {
      query: {
        actor: learnerData.uid,
        verb: "readBook",
        target: assignmentData.uid,
      },
    };
    let res = await getUserLogs(params);
    //console.log("*********", res.data.data);
    res.data = res.data.data;
    if (res.data.length > 0) {
      let params1 = {
        query: {
          actor: learnerData.uid,
          verb: "readBook",
          context: {
            assetId: res.data[0]["context"]["assetId"],
          },
        },
      };
      let res1 = await getUserLogs(params1);
      res1.data = res1.data.data;
      //console.log("*********", res1.data);
      let tempObj = null;
      let tempTime = 0;
      for (let u = 0; u < res1.data.length; u++) {
        let dt = new Date(res1.data[u]["updatedAt"]);
        let tempTime1 = dt.getTime();
        if (tempObj == null) {
          tempObj = res1.data[u];
        } else {
          if (tempTime < tempTime1) {
            tempObj = res1.data[u];
            tempTime = tempTime1;
          }
        }
      }

      //console.log("%%%%%%%%", tempObj);

      let tempArr = tempObj.outcome.pagesRecord;
      let arr = tempArr.filter(filterNullAudio);

      if (arr.length > 0) {
        res.data[0] = tempObj;

        if (res.data.length > 0 && res.data[0]["outcome"] != undefined) {
          let recordings = res.data[0]["outcome"]["pagesRecord"];
          let audiosToFetch = [];

          let assignmentname = assignmentData.title.split(" ").join("_");
          let port = sessionStorage.getItem("port_data")
            ? sessionStorage.getItem("port_data").split(",")
            : process.env.REACT_APP_PORT_DATA.split(",");

          // ================================================
          let usernamesplit = userInfo.username.split("@");
          let alias = usernamesplit[usernamesplit.length - 1];

          let folder = null;
          let foundOneAudio = recordings.find((o) => {
            return (
              o["recordedAudio"] != undefined && o["recordedAudio"] != null
            );
          });
          let uri = `${
            sessionStorage.getItem("site_ip")
              ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
              : process.env.REACT_APP_SERVER_API
          }/media/userUploadedData/${alias}/${foundOneAudio.recordedAudio}`;
          const result = await fetch(uri, { method: "HEAD" }).catch((err) => {
            console.log("okerr");
          });

          console.log("result", result);
          if (!result.ok) {
            uri = `${
              sessionStorage.getItem("site_ip")
                ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                : process.env.REACT_APP_SERVER_API
            }/media/userUploadedData/default/${foundOneAudio.recordedAudio}`;
            const result1 = await fetch(uri, { method: "HEAD" }).catch(
              (err) => {
                console.log("okerr");
              }
            );
            if (!result1.ok) {
              folder = `media_2024/userUploadedData`;
            } else {
              folder = `media/userUploadedData/default`;
            }
          } else {
            folder = `media/userUploadedData/${alias}`;
          }

          // ===================================================

          for (let x = 0; x < recordings.length; x++) {
            if (
              recordings[x]["recordedAudio"] != undefined &&
              recordings[x]["recordedAudio"] != null
            ) {
              audiosToFetch.push(
                `${
                  sessionStorage.getItem("site_ip")
                    ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
                    : process.env.REACT_APP_SERVER_API
                }/${folder}/${recordings[x]["recordedAudio"]}`
              );
            }
          }

          var crunker = new Crunker();
          const buffers = await crunker.fetchAudio(...audiosToFetch);
          const merged = await crunker["concatAudio"](buffers);
          const output = await crunker.export(merged, "audio/mp3");
          var arrayBuffer = await output.blob.arrayBuffer();
          //console.log("%%%%%%%%earrayBuffer", arrayBuffer);

          let mp3Worker = new Worker(worker_script);
          mp3Worker.postMessage({
            arrayBuffer: arrayBuffer,
            link: `${window.location.origin}/js/lame.min.js`,
          });

          mp3Worker.onmessage = async (e) => {
            //console.log("%%%%%%%%e", e);
            await crunker.download(
              e.data,
              `${assignmentname}_${randomNumber(5000)}`
            );
            mp3Worker.terminate();
          };
        } else {
          // this.$q.notify({
          //   type: "info",
          //   message: "Not Attempted",
          // });
        }
      } else {
        // document.getElementById("loader").style.display = "none";
        // this.$q.notify({
        //   type: "info",
        //   message: "Not Recorded yet",
        // });
      }
    } else {
      // document.getElementById("loader").style.display = "none";
      // this.$q.notify({
      //   type: "info",
      //   message: "Not Attempted",
      // });
    }
  };

  const filterNullAudio = (value) => {
    if (value.recordedAudio != null && value.visitedOn.length > 0) {
      return value;
    }
  };

  let ratingDone = async (rating) => {
    console.log("tasks", tasks[0]["tags"]["tags"]);
    let logObj = {
      actor: learnerData.uid,
      verb: "ratingAssignment",
      outcome: { session_uid: sessionUid, learnerRating: rating },
      site_uuid: userInfo.site_uuid,
      target: assignmentData.uid,
      context: null,
      session_uid: null,
    };
    let logResponse = await userLogs(logObj);

    if (
      logResponse &&
      tasks[0]["tags"]["tags"].indexOf("Special Assessment") > -1
    ) {
      let logupdated = await upsertSelfLearnProgress(
        userInfo.uid,
        assignmentData.uid,
        userInfo.site_uuid,
        tasks[0]["tags"]["tags"].indexOf("Special Assessment") > -1
          ? "extraLog"
          : "regularLog"
      );

      if (logupdated) {
        let logObj2 = {
          actor: userInfo.uid,
          verb: "specialExamLog",
          outcome: { session_uid: sessionUid },
          site_uuid: userInfo.site_uuid,
          target: assignmentData.uid,
          context: null,
          session_uid: null,
        };
        let logResponses = await userLogs(logObj2);
        setRatingModl(false);
      }
    }

    if (logResponse) {
      setRatingModl(false);
      navigation(-1);
    }
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: "center",
          }}
        >
          <Grid item xs={5}>
            <Box sx={{ width: "100%", ml: 4 }}>
              <List dense sx={{ py: 0, px: 1 }}>
                <ListItem>
                  <ListItemSecondaryAction
                    sx={{ top: "42%" }}
                    onClick={() => {
                      if (ratingNotAvailable) {
                        setRatingModl(true);
                      }
                    }}
                  >
                    <Slide
                      direction="down"
                      timeout={500}
                      in={true}
                      mountOnEnter
                      unmountOnExit
                    >
                      <img src={require('../../../assets/starBadgh.png')} width="60vw"></img>
                    </Slide>
                    <Box
                      sx={{
                        position: "absolute",
                        right: 0,
                        zIndex: 1,
                        top: 1,
                        borde: 1,
                        borderColor: "#DB8829",
                        borderRadius: 50,
                        backgroundColor: "#DB8829",
                        color: "#FFFFFF",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        width: "1rem",
                        height: "1rem",
                        textAlign: "center",
                        padding: 0.1,
                        "@media (min-width: 1636px)": {
                          width: "1.4rem",
                          height: "1.4rem",
                          fontSize: "1rem",
                          right: 0,
                          top: 1,
                        },
                      }}
                    >
                      {learnerRating}
                    </Box>
                  </ListItemSecondaryAction>

                  {learnerData && (
                    <ListItemText
                      sx={{ color: "primary.main" }}
                      primary={
                        <Typography
                          width="80%"
                          sx={{
                            fontSize: "1.6rem",
                            fontWeight: "bold",
                            wordWrap: "break-word",
                            "@media (min-width: 1636px)": {
                              fontSize: "2.2rem",
                            },
                          }}
                          color="#DB8829"
                        >
                          {assignmentData.title}
                        </Typography>
                      }
                      secondary={
                        <>
                          <Typography
                            width="80%"
                            sx={{
                              fontSize: "1rem",
                              wordBreak: "break-all",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.2rem",
                              },
                            }}
                            color="#DB8829"
                          >
                            Assignment Report for:{" "}
                            {joinByKeys(
                              learnerData.name,
                              ["firstname", "lastname"],
                              " "
                            )}
                          </Typography>
                          {tasks &&
                            tasks.length > 0 &&
                            tasks[0]["tags"]["tags"].indexOf(
                              "Special Assessment"
                            ) > -1 && (
                              <Typography
                                width="80%"
                                sx={{
                                  fontSize: "1rem",
                                  wordBreak: "break-all",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.2rem",
                                  },
                                }}
                                color="#DB8829"
                              >
                                Assessment Level: {assessmentLevel}
                              </Typography>
                            )}
                        </>
                      }
                    />
                  )}
                </ListItem>
              </List>
            </Box>
            <Box
              sx={{
                border: 1,
                borderColor: "#EAECEE",
                borderRadius: 10,
                py: 3,
                mt: 1,
                ml: 5,
              }}
            >
              <Box>
                <Grid
                  container
                  sx={{
                    flexDirection: "row",
                    flexFlow: "wrap",
                    justifyContent: "space-around",
                    px: 3,
                    alignItems: "center",
                  }}
                >
                  {learnerData && (
                    <>
                      <Grid item>
                        <CircleProgressBar
                          circleVal={
                            (learnerData.totalAssets /
                              learnerData.totalAssets) *
                            100
                          }
                        />
                      </Grid>
                      <Grid item>
                        <CircleProgressBar
                          circleVal={
                            (learnerData.attemptedassets /
                              learnerData.totalAssets) *
                            100
                          }
                        />
                      </Grid>
                      <Grid item>
                        <CircleProgressBar
                          circleVal={
                            (correctAsset / learnerData.totalAssets) * 100
                          }
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
                <Grid
                  container
                  sx={{
                    flexDirection: "row",
                    flexFlow: "wrap",
                    justifyContent: "space-around",
                    px: 2,
                    pt: 2,
                    alignItems: "center",
                  }}
                >
                  {learnerData && (
                    <>
                      <Grid item>
                        <Typography
                          sx={{
                            color: "primary.main",
                            fontSize: "0.9rem",
                            pl: 2,
                            fontWeight: "500",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                              pl: 3,
                            },
                          }}
                        >
                          Assets: {learnerData.totalAssets}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          sx={{
                            color: "primary.main",
                            fontSize: "0.9rem",
                            fontWeight: "500",
                            pl: 2,
                            "@media (min-width: 1636px)": {
                              fontSize: "1.4rem",
                              pl: 4,
                            },
                          }}
                        >
                          Attempted: {learnerData.attemptedassets}
                        </Typography>
                      </Grid>
                      {correctAsset && (
                        <Grid item>
                          <Typography
                            sx={{
                              color: "primary.main",
                              fontSize: "0.9rem",
                              fontWeight: "500",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                                pr: 2,
                              },
                            }}
                          >
                            Correct: {correctAsset.toFixed(2)}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>
              </Box>
              <Box sx={{ pt: 2, px: 6 }}>
                {learnerData && (
                  <StudentCardProgress value={learnerData.percentage} />
                )}
              </Box>
              <Box sx={{ textAlign: "center", mt: 2 }}>
                {learnerData && (
                  <Typography
                    sx={{
                      color: "#A9A9A9",
                      fontSize: "0.6rem",
                      "@media (min-width: 1636px)": { fontSize: "1rem" },
                    }}
                  >
                    Auto-evaluation:{" "}
                    {learnerData.totalAssets -
                      exeToEval.length -
                      exeNotToEval.length}{" "}
                    | Teacher-evaluation: {exeToEval.length} | Self-evaluation:{" "}
                    {exeNotToEval.length}
                    {siteConfig?.customer?.addOnInfo?.isEstimatedDuration
                      ? ` | Duration : ${getFormatedTime(
                          assignmentData.estimated_time,
                          "HH:mm:ss"
                        )} Hrs`
                      : ""}
                  </Typography>
                )}
              </Box>
              {assignmentSummaryLog && assignmentSummaryLog.length > 0 && (
                <>
                  <Box
                    sx={{
                      mt: 2,
                      borderTop: 2,
                      pt: 2,
                      borderTopColor: "#cccccc",
                      borderTopStyle: "dashed",
                    }}
                    onClick={() => {
                      setPolarChartVisible(true);
                    }}
                  >
                    <PolarChart polarChartData={assignmentSummaryLog[0]} />
                    <Box sx={{ textAlign: "end", mr: 1 }}>
                      <IconButton
                        sx={{
                          backgroundColor: "#F5F7FF",
                          color: "#DB8829",
                        
                        }}
                      >
                        <FullscreenIcon />
                      </IconButton>
                    </Box>
                  </Box>
                  <PolarChartModal
                    show={polarChartVisible}
                    toggleModal={(flag) => setPolarChartVisible(flag)}
                    polarChartData={assignmentSummaryLog[0]}
                  />
                </>
              )}
            </Box>
          </Grid>
          <Grid item xs={7} sx={{ mt: 2, mx: 4 }}>
            {assetData && (
              <Box
                 
                onScroll={() => {
                  if (handleInfinityScroll()) {
                    handleLoadMore();
                  }
                }}
                ref={listInnerRef}
                sx={{ height: "79vh", overflow: "auto", textAlign: "center" }}
              >
                <>
                  {assetData &&
                    assetData.map((resAssetData, index) => {
                      return (
                        <CardAssetList
                          key={`card_assets${index}`}
                          resAssetData={resAssetData}
                          index={index}
                        />
                      );
                    })}
                  {assetData &&
                    process.env.REACT_APP_DOWNLOAD_ALLOW == "true" &&
                    assetData.length > 0 &&
                    assetData[0].assetType?.toUpperCase() == "BOOK" && (
                      <Button
                        variant="contained"
                        onClick={downloadBook}
                        startIcon={<CloudDownloadIcon />}
                        sx={{
                          borderRadius: 10,
                          fontWeight: "600",
                          backgroundColor: "#F5F5F5",
                          color: "primary.main",
                          boxShadow: 0,
                          textTransform: "inherit",
                        
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                          },
                        }}
                      >
                        Download recorded library book's audio.
                      </Button>
                    )}
                </>
              </Box>
            )}
          </Grid>
          <RatingModal
            visible={ratingModl}
            toggleModal={(flag) => setRatingModl(flag)}
            done={(rating) => {
              ratingDone(rating);
            }}
          ></RatingModal>
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default LearnerAssetList;
